export default Object.freeze({
  NoDuration: 'NoDuration',
  FixedDuration: 'FixedDuration',
  PerParticipant: 'PerParticipant',
  ParallelScheduling: 'ParallelScheduling',
})
